import { RouteComponentProps, useLocation } from '@gatsbyjs/reach-router'
import { useEffect, useState } from 'react';
import MutualFundApiServices from '../../Services/MutualFundServices';
import NomineeMasterTable from '../../Models/NomineeMasterTable';
import { CircularProgress, Divider } from '@mui/material';
import { useAPForm, getIt, handleErrorMessage, APColumn, APSizedBox, APSpacing, APImage, APScrollView, APForm, APText, APFormFieldText, APFormFieldDropdown, APFormFieldCheckbox, REGEX, APRow, APFormSubmit, launchDialog, APCenter, APFormFieldFile, convertBase64, APFormFieldRadio } from 'ap-components';
import { NRITinDetails, NRITinFormReq, } from '../../Models/NomineeDeclarationModel';


export default function UpdateNomineeDetails(_props: RouteComponentProps) {
    const location = useLocation()
    const token = new URLSearchParams(location.search).get("tkn")
    const control = useAPForm()
    const [counter, setCounter] = useState(0);
    const [form] = useState<NRITinFormReq>({ fatcaIdentificationType: "T", fatcaTin: "", fatcaTinTaxStatus: "individual", nriUploadedFile: null });
    const [nriTinDetails, setNriTinDetails] = useState<NRITinDetails>();
    const [isMobile, setIsMobile] = useState(false);
    const [tinTaxStatus, setTinTaxStatus] = useState<"individual" | "entity">("individual");

    useEffect(() => {
        getDetails();
    }, [token]);

    async function getDetails() {
        if (!token) {
            return
        }
        try {
            const res = await getIt(MutualFundApiServices).getNRIFatcaDetails(token);
            form.fatcaIdentificationType = res.noTin ? 'D' : 'T';
            if (res.nriTinUpdatedAt) {
                form.fatcaIdentificationType = res.fatcaIdType ?? form.fatcaIdentificationType;
                form.fatcaTin = res.fatcaTpin ?? '';
            }
            form.fatcaTinTaxStatus = res.fatcaTinTaxStatus ?? "individual";
            setNriTinDetails(res);
        } catch (error) {
            handleErrorMessage(error);
        }
    }
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 600);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!nriTinDetails) {
        return (
            <APColumn mainAxisSize='max' crossAxisAlignment='stretch'>
                <APCenter>
                    <CircularProgress />
                </APCenter>
            </APColumn>
        )
    }


    return (
        <APColumn mainAxisSize='max' style={{ padding: "16px", width: "100vw" }}>
            <APSizedBox height={APSpacing[5]} />
            <APImage src='/assetplus/aplight.svg' height="24px" width="180.85px" />
            <APSizedBox height={APSpacing[5]} />
            <APScrollView>
                <APForm control={control}>
                    <APColumn crossAxisAlignment='center' mainAxisAlignment='center'>
                        <APColumn crossAxisAlignment='stretch' style={{ maxWidth: "min(500px, 100%)" }} mainAxisAlignment='center' >
                            <APText variant='maintext'>Hi {nriTinDetails.name}, as per RTA's regulations, please update your TIN details, to avoid restrictions on new transactions. Ongoing SIPs, STPs, and SWPs will continue unaffected.</APText>
                            <APSizedBox height={APSpacing[6]} />
                            <APText variant='h3'>TIN Details</APText>
                            <APFormFieldDropdown
                                label='Tax Country'
                                initialValue={nriTinDetails.fatcaCountry}
                                disabled={true}
                                items={
                                    NomineeMasterTable.TAX_COUNTRY.map((e: any) => (
                                        {
                                            value: e.code,
                                            label: e.label
                                        }
                                    ))
                                }
                            />


                            <APFormFieldDropdown<string>
                                label='ID Type'
                                initialValue={form.fatcaIdentificationType}
                                // disabled={!nriTinDetails.noTin}
                                validator={(v) => {
                                    v = v?.trim() ?? "";
                                    if (!v || v.length === 0) {
                                        return "Please select the ID Type";
                                    }
                                    return null;
                                }}
                                style={{ maxWidth: isMobile ? "400px" : "100%" }}
                                onChanged={(v) => {
                                    setCounter(prev => ++prev);
                                    form.fatcaIdentificationType = v ?? "";
                                }}
                                items={
                                    NomineeMasterTable.TIN_ALTERNATE_TAX_ID.map((e: any) => (
                                        {
                                            value: e.code,
                                            label: e.label
                                        }
                                    ))
                                }
                            />

                            {/* <APFormFieldRadio
                                label="Select Tin Status"
                                helperText="Please select one option"
                                initialValue={form.fatcaTinTaxStatus}
                                items={[
                                    {
                                        value: "individual",
                                        label: "Individual",
                                    },
                                    {
                                        value: "entity",
                                        label: "Entity",
                                    }
                                ]}
                                validator={(v) => {
                                    if (!v) {
                                        return "Please select one option"
                                    }
                                    return null
                                }}
                                onChanged={(value) => {
                                    form.fatcaTinTaxStatus = value as "individual" | "entity";
                                    setTinTaxStatus(value as "individual" | "entity");
                                }}
                            /> */}
                            <APFormFieldCheckbox
                                label='Select this if you are updating TIN details as a business or legal entity.'
                                initialValue={form.fatcaTinTaxStatus == "entity"}
                                onChanged={(v) => {
                                    form.fatcaTinTaxStatus = v ? 'entity' : 'individual';
                                    setTinTaxStatus(form.fatcaTinTaxStatus);
                                }}
                            />
                            <APFormFieldText
                                label='Tax ID'
                                initialValue={form.fatcaTin}
                                key={`Tax_KEY_${form.fatcaIdentificationType}`}
                                validator={(v) => {
                                    v = v.trim();
                                    if (!v) {
                                        return "Please Enter the Tax ID";
                                    }
                                    else if (form.fatcaIdentificationType === "T") {
                                        const tinRegex = tinTaxStatus === "individual" ? nriTinDetails.individualRegex : nriTinDetails.entitiesRegex;
                                        if (!new RegExp(tinRegex).test(v)) {
                                            return "Please enter the valid Tax Id";
                                        }
                                    }
                                    else if (v.length < 3) {
                                        return "Atleast 3 letters";
                                    }

                                    return null;
                                }}
                                helperText={form.fatcaIdentificationType !== "T" ? 'Enter the Tax ID exactly as on the document, including any spaces, hyphens (-), or other characters, etc.' : `Sample Text: ${tinTaxStatus === "individual" ? nriTinDetails.individualSampleText : nriTinDetails.entitiesSampleText}`}
                                onChanged={(v) => {
                                    form.fatcaTin = v.trim();
                                }}
                            />
                            {
                                (form.fatcaIdentificationType !== "T") && (
                                    <APFormFieldFile
                                        label="Upload proof"
                                        accept="image/*,application/pdf"
                                        onChanged={(v) => {
                                            form.nriUploadedFile = v
                                        }}
                                        validator={(v) => {
                                            if (!v) {
                                                return "Attach proof"
                                            }
                                            return null
                                        }}
                                    />
                                )
                            }

                            <Divider />
                            <APRow mainAxisAlignment='center'>
                                <APFormSubmit
                                    type='primary'
                                    size='medium'
                                    onClick={async () => {
                                        if (await control.validate()) {
                                            try {
                                                if (!token) {
                                                    throw new Error("Unathourized Access")
                                                }

                                                if (form.fatcaIdentificationType !== "T" && form.nriUploadedFile) {
                                                    // converts file to base64
                                                    form.nriUploadedBase64 = await convertBase64(form.nriUploadedFile) as string;
                                                    delete form.nriUploadedFile
                                                }

                                                await getIt(MutualFundApiServices).updateTinFatca(form, token);
                                                window.location.href = "/nri_tin_regulatory_validation/successPage";
                                            } catch (error) {
                                                handleErrorMessage(error)
                                            }
                                        }
                                    }}
                                >
                                    Submit
                                </APFormSubmit>
                            </APRow>
                        </APColumn>
                    </APColumn>
                </APForm>
            </APScrollView>
        </APColumn >
    );
}

export class NRVNomineeValidationModel {
    name!: string;
    relationship!: string;
    relationshipCode!: string;
}

export class NRVGuardianValidationModel {
    name!: string;
    relationshipCode!: string;
}
